module.exports = __webpack_public_path__ + "static/media/bazaar.f69a90d5.svg";